import router from "../router";
// 使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
  // // 跳转到pc
  // if (!/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
  //   let url = "https://wan4.com/";
  //   if (process.env.NODE_ENV == "development") {
  //     url = "http://192.168.9.168:83/";
  //   }
  //   if (to.path == "/goods/details") {
  //     url += `partslist/goodsdetails/${to.query.oid}?odid=${to.query.odid || ''}`;
  //   }
  //   window.location.href = url;
  //   return;
  // }
  next();
});
